// torre-platform · TI/Governança — Saúde Dados + Orq + Agents + EvBus + Gov
import {
  initAuth, getAuthContext, signInWithGoogle, signInWithMagicLink,
  applyTheme, createOrbitBackground,
  fetchJson, fmtBR, fmtDate, fmtDateTime, escapeHtml, SUPABASE
} from '@zzyonbr/torre-shared';

const $ = sel => document.querySelector(sel);
const $$ = sel => Array.from(document.querySelectorAll(sel));

async function bootstrap() {
  await initAuth();
  const ctx = await getAuthContext();
  applyTheme(ctx.tenant?.branding || {});
  if (!ctx.user) { renderLogin(); return; }
  renderShell(ctx);
  setActiveTab(location.hash.slice(1) || 'saude-dados');
  window.addEventListener('hashchange', () => setActiveTab(location.hash.slice(1) || 'saude-dados'));
}

function renderLogin() {
  $('#app').innerHTML = `
    <div class="zzy-fade-up" style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;position:relative;overflow:hidden">
      <div id="orbit-host" style="position:absolute;inset:0;pointer-events:none"></div>
      <div class="zzy-card" style="max-width:440px;width:100%;text-align:center;padding:48px 36px">
        <div style="display:flex;justify-content:center;margin-bottom:28px"><zzy-logo size="56" sub="true"></zzy-logo></div>
        <div style="font:400 13px/1.4 var(--zzy-font);color:var(--zzy-text-mute);font-style:italic;margin-bottom:32px">Inteligência em órbita</div>
        <div style="height:1px;background:var(--zzy-border);margin:0 -36px 28px -36px"></div>
        <div class="zzy-eyebrow" style="margin-bottom:8px">Torre de Controle</div>
        <div class="zzy-h3" style="margin-bottom:28px">Platform · TI</div>
        <button id="login-google" class="zzy-btn" style="width:100%;background:#FFFFFF;color:#1F1F1F;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:12px">
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Entrar com Google
        </button>
        <div style="display:flex;align-items:center;gap:10px;margin:14px 0;color:var(--zzy-text-mute);font:400 11px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.1em">
          <span style="flex:1;height:1px;background:var(--zzy-border)"></span>ou<span style="flex:1;height:1px;background:var(--zzy-border)"></span>
        </div>
        <input id="email" type="email" placeholder="seu.email@empresa.com" class="zzy-input" style="margin-bottom:12px" />
        <button id="login-btn" class="zzy-btn zzy-btn--ghost" style="width:100%">Receber Magic Link por email</button>
        <div id="login-msg" style="margin-top:14px;font:400 12px/1.4 var(--zzy-font);color:var(--zzy-text-mute);min-height:18px"></div>
      </div>
    </div>
  `;
  $('#orbit-host')?.appendChild(createOrbitBackground());
  $('#login-google').addEventListener('click', () => signInWithGoogle(location.origin).catch(e => $('#login-msg').textContent = 'Erro: ' + e.message));
  $('#login-btn').addEventListener('click', async () => {
    const email = $('#email').value.trim();
    if (!email) { $('#login-msg').textContent = 'Informe um email'; return; }
    try { await signInWithMagicLink(email, location.origin); $('#login-msg').textContent = 'Link enviado!'; $('#login-msg').style.color = 'var(--zzy-success)'; }
    catch (err) { $('#login-msg').textContent = 'Erro: ' + err.message; $('#login-msg').style.color = 'var(--zzy-danger)'; }
  });
}

function renderShell(ctx) {
  $('#app').innerHTML = `
    <zzy-toast></zzy-toast>
    <zzy-header module="Platform · TI"></zzy-header>
    <main style="max-width:1500px;margin:0 auto;padding:24px">
      <nav id="tabs" style="display:flex;gap:8px;margin-bottom:20px;border-bottom:1px solid var(--zzy-border);overflow-x:auto">
        <button data-tab="saude-dados" class="pl-tab pl-tab--active">Saúde Dados</button>
        <button data-tab="orq"          class="pl-tab">Orquestração</button>
        <button data-tab="agents"       class="pl-tab">Agents</button>
        <button data-tab="evbus"         class="pl-tab">Event Bus</button>
        <button data-tab="gov"          class="pl-tab">Governança</button>
      </nav>
      <section id="content"></section>
    </main>
    <style>
      .pl-tab { background:transparent;border:0;color:var(--zzy-text-mute);padding:10px 18px;font:500 13px/1 var(--zzy-font);cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1px;transition:color .15s,border-color .15s;white-space:nowrap; }
      .pl-tab:hover { color:var(--zzy-mist); }
      .pl-tab--active { color:var(--zzy-sky);border-bottom-color:var(--zzy-sky); }
      .pl-table { width:100%;border-collapse:collapse;font-size:12.5px; }
      .pl-table th { text-align:left;color:var(--zzy-text-mute);font:600 10px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.08em;padding:10px 12px;border-bottom:1px solid var(--zzy-border);position:sticky;top:0;background:var(--zzy-surface-solid);z-index:1; }
      .pl-table td { padding:10px 12px;border-bottom:1px solid var(--zzy-border);vertical-align:top; }
      .pl-table tr:hover td { background:rgba(255,255,255,.02); }
      .pl-stat { display:flex;gap:12px;flex-wrap:wrap;margin-bottom:20px; }
      .pl-badge { display:inline-block;padding:2px 8px;border-radius:4px;font:600 10px/1.4 var(--zzy-font);text-transform:uppercase;letter-spacing:.04em; }
      .pl-status-ok    { background:rgba(34,197,94,.18);color:#22C55E; }
      .pl-status-warn  { background:rgba(245,158,11,.18);color:#F59E0B; }
      .pl-status-crit  { background:rgba(239,68,68,.18);color:#EF4444; }
      .pl-status-mute  { background:rgba(255,255,255,.06);color:var(--zzy-text-mute); }
    </style>
  `;
  $$('.pl-tab').forEach(b => b.addEventListener('click', () => { location.hash = b.dataset.tab; setActiveTab(b.dataset.tab); }));
}

function setActiveTab(name) {
  $$('.pl-tab').forEach(b => b.classList.toggle('pl-tab--active', b.dataset.tab === name));
  if (name === 'saude-dados') loadSaudeDados();
  if (name === 'orq')         loadOrq();
  if (name === 'agents')      loadAgents();
  if (name === 'evbus')       loadEvBus();
  if (name === 'gov')         loadGov();
}

// ============================================================
// ABA · SAÚDE DADOS (freshness + 15 checks fidelidade)
// ============================================================
async function loadSaudeDados() {
  $('#content').innerHTML = `<zzy-spinner>Carregando saúde dados…</zzy-spinner>`;
  try {
    const [freshness, checks] = await Promise.all([
      fetchJson('/vw_etl_freshness?select=*').catch(() => []),
      fetchJson('/vw_data_integrity_status?select=*').catch(() => [])
    ]);
    const totalFontes = freshness.length;
    const fontesOk = freshness.filter(f => (f.minutos_desde_ultima || 0) < 60).length;
    const fontesStale = freshness.filter(f => (f.minutos_desde_ultima || 0) >= 60).length;
    const checksOk = checks.filter(c => c.status === 'OK').length;
    const checksAtencao = checks.filter(c => c.status === 'ATENCAO').length;
    const checksCritico = checks.filter(c => c.status === 'CRITICO').length;

    $('#content').innerHTML = `
      <div class="pl-stat">
        <zzy-stat-card label="Fontes ETL"   value="${fmtBR(totalFontes)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Frescas <1h"  value="${fmtBR(fontesOk)}" color="success"></zzy-stat-card>
        <zzy-stat-card label="Stale"        value="${fmtBR(fontesStale)}" color="warning"></zzy-stat-card>
        <zzy-stat-card label="Checks OK"    value="${fmtBR(checksOk)}" color="success"></zzy-stat-card>
        <zzy-stat-card label="Atenção"      value="${fmtBR(checksAtencao)}" color="warning"></zzy-stat-card>
        <zzy-stat-card label="CRÍTICO"      value="${fmtBR(checksCritico)}" color="danger"></zzy-stat-card>
      </div>

      <div class="zzy-card" style="margin-bottom:16px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
          <h3 class="zzy-h3" style="margin:0">🛡️ Checks de Fidelidade</h3>
          <div style="display:flex;gap:8px">
            <button class="zzy-btn zzy-btn--ghost" onclick="window.__runChecks()" style="padding:8px 14px">Rodar checks agora</button>
            <button class="zzy-btn zzy-btn--ghost" onclick="window.__alertChecks()" style="padding:8px 14px">Disparar alerta WhatsApp</button>
          </div>
        </div>
        <div style="overflow:auto;max-height:400px">
          <table class="pl-table">
            <thead><tr><th>Check</th><th>Status</th><th>Valor</th><th>Threshold</th><th>Última execução</th></tr></thead>
            <tbody>
              ${checks.length ? checks.map(c => {
                const cls = c.status === 'OK' ? 'pl-status-ok' : c.status === 'ATENCAO' ? 'pl-status-warn' : c.status === 'CRITICO' ? 'pl-status-crit' : 'pl-status-mute';
                return `<tr>
                  <td><strong>${escapeHtml(c.check_id || c.nome || '—')}</strong>${c.descricao ? `<br><small style="color:var(--zzy-text-mute)">${escapeHtml(c.descricao.slice(0,80))}</small>` : ''}</td>
                  <td><span class="pl-badge ${cls}">${escapeHtml(c.status || '—')}</span></td>
                  <td>${c.valor != null ? fmtBR(c.valor) : '—'}</td>
                  <td>${c.threshold != null ? fmtBR(c.threshold) : '—'}</td>
                  <td><small>${fmtDateTime(c.ultima_execucao || c.executed_at)}</small></td>
                </tr>`;
              }).join('') : '<tr><td colspan="5"><zzy-empty title="Sem checks ainda" message="Cria a tabela data_integrity_checks com 15 regras + cron 06h"></zzy-empty></td></tr>'}
            </tbody>
          </table>
        </div>
      </div>

      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">📊 Catálogo de Fontes (freshness)</h3>
        <div style="overflow:auto">
          <table class="pl-table">
            <thead><tr><th>Fonte</th><th>Tipo</th><th>Última atualização</th><th>Min atrás</th><th>Status</th></tr></thead>
            <tbody>
              ${freshness.length ? freshness.map(f => {
                const min = Math.round(f.minutos_desde_ultima || 0);
                const cls = min < 60 ? 'pl-status-ok' : min < 360 ? 'pl-status-warn' : 'pl-status-crit';
                const label = min < 60 ? 'FRESCA' : min < 360 ? 'STALE' : 'MUITO VELHA';
                return `<tr>
                  <td><strong>${escapeHtml(f.fonte || f.source || '—')}</strong></td>
                  <td><small>${escapeHtml(f.tipo || f.type || '—')}</small></td>
                  <td>${fmtDateTime(f.ultima_atualizacao || f.last_seen)}</td>
                  <td>${min}min</td>
                  <td><span class="pl-badge ${cls}">${label}</span></td>
                </tr>`;
              }).join('') : '<tr><td colspan="5"><zzy-empty title="Sem catálogo de fontes" message="View vw_etl_freshness não acessível"></zzy-empty></td></tr>'}
            </tbody>
          </table>
        </div>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

window.__runChecks = async () => {
  if (!confirm('Rodar todos os 15 checks de fidelidade agora?')) return;
  window.zzyToast?.('Rodando checks…', 'info');
  try {
    await fetchJson(`${SUPABASE.url}/functions/v1/data-integrity-alerter`, {
      method: 'POST', body: { trigger: 'manual', skip_alerts: true }
    });
    window.zzyToast?.('Checks completos!', 'success');
    setTimeout(loadSaudeDados, 1000);
  } catch (err) {
    window.zzyToast?.(`Erro: ${err.message}`, 'danger');
  }
};

window.__alertChecks = async () => {
  if (!confirm('Disparar WhatsApp de alerta para checks CRÍTICOS?')) return;
  window.zzyToast?.('Disparando alertas…', 'info');
  try {
    await fetchJson(`${SUPABASE.url}/functions/v1/data-integrity-alerter`, {
      method: 'POST', body: { trigger: 'manual', force_alert: true }
    });
    window.zzyToast?.('Alertas disparados!', 'success');
  } catch (err) {
    window.zzyToast?.(`Erro: ${err.message}`, 'danger');
  }
};

// ============================================================
// ABA · ORQUESTRAÇÃO
// ============================================================
async function loadOrq() {
  $('#content').innerHTML = `<zzy-spinner>Carregando orquestração…</zzy-spinner>`;
  try {
    const [tasks, runs, audit] = await Promise.all([
      fetchJson('/cs_orchestrator_tasks?select=*&order=created_at.desc&limit=20').catch(() => []),
      fetchJson('/cs_orchestrator_runs?select=*&order=started_at.desc&limit=20').catch(() => []),
      fetchJson('/cs_orchestrator_audit?select=*&order=created_at.desc&limit=20').catch(() => [])
    ]);
    $('#content').innerHTML = `
      <div class="pl-stat">
        <zzy-stat-card label="Tasks ativas" value="${fmtBR(tasks.length)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Runs recentes" value="${fmtBR(runs.length)}" color="info"></zzy-stat-card>
        <zzy-stat-card label="Audit logs" value="${fmtBR(audit.length)}" color="primary"></zzy-stat-card>
      </div>

      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">📋 Tasks orquestradas</h3>
        ${tasks.length ? `<div style="overflow:auto"><table class="pl-table">
          <thead><tr><th>ID</th><th>Tipo</th><th>Status</th><th>Criada</th><th>Owner</th></tr></thead>
          <tbody>${tasks.map(t => `<tr>
            <td><code style="font-size:11px">${escapeHtml((t.id || '').slice(0, 8))}</code></td>
            <td>${escapeHtml(t.tipo || t.type || '—')}</td>
            <td><span class="pl-badge ${t.status === 'completed' ? 'pl-status-ok' : t.status === 'failed' ? 'pl-status-crit' : 'pl-status-warn'}">${t.status || '—'}</span></td>
            <td><small>${fmtDateTime(t.created_at)}</small></td>
            <td>${escapeHtml(t.owner || '—')}</td>
          </tr>`).join('')}</tbody></table></div>` : '<zzy-empty title="Sem tasks orquestradas"></zzy-empty>'}
      </div>

      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">🏃 Runs recentes</h3>
        ${runs.length ? `<div style="overflow:auto"><table class="pl-table">
          <thead><tr><th>Task</th><th>Status</th><th>Iniciado</th><th>Concluído</th><th>Duração</th></tr></thead>
          <tbody>${runs.map(r => {
            const dur = r.completed_at && r.started_at ? Math.round((new Date(r.completed_at) - new Date(r.started_at))/1000) + 's' : '—';
            return `<tr>
              <td><code style="font-size:11px">${escapeHtml((r.task_id || '').slice(0,8))}</code></td>
              <td><span class="pl-badge ${r.status === 'completed' ? 'pl-status-ok' : r.status === 'failed' ? 'pl-status-crit' : 'pl-status-warn'}">${r.status || '—'}</span></td>
              <td><small>${fmtDateTime(r.started_at)}</small></td>
              <td><small>${fmtDateTime(r.completed_at)}</small></td>
              <td>${dur}</td>
            </tr>`;
          }).join('')}</tbody></table></div>` : '<zzy-empty title="Sem runs"></zzy-empty>'}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · AGENTS
// ============================================================
async function loadAgents() {
  $('#content').innerHTML = `<zzy-spinner>Carregando agents…</zzy-spinner>`;
  try {
    const agents = await fetchJson('/agents_status?select=*').catch(() =>
      fetchJson('/cs_agents?select=*').catch(() => [])
    );
    const fns = await fetchJson('/edge_functions_health?select=*').catch(() => []);

    $('#content').innerHTML = `
      <div class="pl-stat">
        <zzy-stat-card label="Agents ativos" value="${fmtBR(agents.length)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Edge Functions" value="${fmtBR(fns.length || 8)}" color="info" sub="ra-dispatch + webhook + confirmar + escalações + send-email-ms + enrich"></zzy-stat-card>
      </div>

      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">🤖 Agents IA configurados</h3>
        ${agents.length ? `<table class="pl-table">
          <thead><tr><th>Nome</th><th>Tipo</th><th>Status</th><th>Última execução</th></tr></thead>
          <tbody>${agents.map(a => `<tr>
            <td><strong>${escapeHtml(a.name || a.nome || '—')}</strong></td>
            <td>${escapeHtml(a.tipo || a.type || '—')}</td>
            <td><span class="pl-badge ${a.status === 'active' ? 'pl-status-ok' : 'pl-status-mute'}">${a.status || '—'}</span></td>
            <td>${fmtDateTime(a.last_run || a.ultima_execucao)}</td>
          </tr>`).join('')}</tbody></table>` : `
          <p style="color:var(--zzy-text-mute);font-size:13px">View agents_status não exposta. Edge Functions ativas no projeto:</p>
          <ul style="margin:12px 0;padding-left:24px;color:var(--zzy-cloud);font-size:13px;line-height:1.8">
            <li><strong>ra-dispatch-whatsapp</strong> v6 — disparo botões interativos</li>
            <li><strong>whatsapp-webhook-receiver</strong> v4 — captura cliques + chat Rubens</li>
            <li><strong>ra-confirmar-cliente</strong> v3 — notifica cliente final</li>
            <li><strong>ra-escalacao-followup</strong> v2 — lembrete consolidado</li>
            <li><strong>ra-escalar-rubens</strong> v1 — escalação 1h</li>
            <li><strong>ra-acao</strong> v5 — registra ação manual</li>
            <li><strong>ra-enrich-esl</strong> v2 — cross com ESL/AWB</li>
            <li><strong>send-email-ms</strong> — Microsoft Graph</li>
            <li><strong>data-integrity-alerter</strong> — 15 checks fidelidade</li>
            <li><strong>ra-sync-gsheet</strong> — sync planilha RA</li>
          </ul>
        `}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · EVENT BUS (recent cron events)
// ============================================================
async function loadEvBus() {
  $('#content').innerHTML = `<zzy-spinner>Carregando event bus…</zzy-spinner>`;
  try {
    const events = await fetchJson('/event_bus?select=*&order=created_at.desc&limit=100').catch(() => []);
    const cronRuns = await fetchJson('/cron_job_run_details_recent?select=*&limit=50').catch(() => []);

    $('#content').innerHTML = `
      <div class="pl-stat">
        <zzy-stat-card label="Eventos hoje" value="${fmtBR(events.length)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Cron runs" value="${fmtBR(cronRuns.length)}" color="info"></zzy-stat-card>
      </div>

      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">📡 Eventos recentes</h3>
        ${events.length ? `<div style="overflow:auto;max-height:300px"><table class="pl-table">
          <thead><tr><th>Tipo</th><th>Origem</th><th>Quando</th><th>Payload</th></tr></thead>
          <tbody>${events.map(e => `<tr>
            <td><strong>${escapeHtml(e.event_type || e.tipo || '—')}</strong></td>
            <td>${escapeHtml(e.source || e.origem || '—')}</td>
            <td><small>${fmtDateTime(e.created_at)}</small></td>
            <td><small style="color:var(--zzy-text-mute);font-family:var(--zzy-font-mono);font-size:10px">${escapeHtml(JSON.stringify(e.payload || {}).slice(0, 80))}</small></td>
          </tr>`).join('')}</tbody></table></div>` : `
          <zzy-empty title="Event bus não exposto" message="Configurar via Edge Functions com pg_listen ou trigger emit"></zzy-empty>
        `}
      </div>

      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">⏰ Cron runs (últimos 50)</h3>
        ${cronRuns.length ? `<div style="overflow:auto;max-height:400px"><table class="pl-table">
          <thead><tr><th>Job</th><th>Status</th><th>Iniciado</th><th>Duração</th><th>Mensagem</th></tr></thead>
          <tbody>${cronRuns.map(c => `<tr>
            <td><strong>${escapeHtml(c.jobname || '—')}</strong></td>
            <td><span class="pl-badge ${c.status === 'succeeded' ? 'pl-status-ok' : 'pl-status-crit'}">${c.status || '—'}</span></td>
            <td><small>${fmtDateTime(c.start_time)}</small></td>
            <td>${c.duration_seconds || 0}s</td>
            <td><small style="color:var(--zzy-text-mute)">${escapeHtml((c.return_message || '').slice(0, 60))}</small></td>
          </tr>`).join('')}</tbody></table></div>` : '<zzy-empty title="Cron runs não expostas via REST" message="Acesse via Supabase Dashboard → SQL → SELECT * FROM cron.job_run_details"></zzy-empty>'}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · GOVERNANÇA (audit log)
// ============================================================
async function loadGov() {
  $('#content').innerHTML = `<zzy-spinner>Carregando governança…</zzy-spinner>`;
  try {
    const audit = await fetchJson('/cs_orchestrator_audit?select=*&order=created_at.desc&limit=100').catch(() => []);
    const dispatches = await fetchJson('/ra_dispatch_log?select=*&order=created_at.desc&limit=50').catch(() => []);
    const acoes = await fetchJson('/ra_acoes?select=*&order=created_at.desc&limit=50').catch(() => []);

    $('#content').innerHTML = `
      <div class="pl-stat">
        <zzy-stat-card label="Audit logs" value="${fmtBR(audit.length)}" color="primary"></zzy-stat-card>
        <zzy-stat-card label="Dispatches recentes" value="${fmtBR(dispatches.length)}" color="info"></zzy-stat-card>
        <zzy-stat-card label="Ações registradas" value="${fmtBR(acoes.length)}" color="primary"></zzy-stat-card>
      </div>

      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">📜 Audit log (orquestrador)</h3>
        ${audit.length ? `<div style="overflow:auto;max-height:300px"><table class="pl-table">
          <thead><tr><th>Quando</th><th>Ação</th><th>Resultado</th><th>Operador</th></tr></thead>
          <tbody>${audit.map(a => `<tr>
            <td><small>${fmtDateTime(a.created_at)}</small></td>
            <td><strong>${escapeHtml(a.acao || a.action || '—')}</strong></td>
            <td><small>${escapeHtml((a.resultado || a.result || '').slice(0, 60))}</small></td>
            <td>${escapeHtml(a.operador || a.user || '—')}</td>
          </tr>`).join('')}</tbody></table></div>` : '<zzy-empty title="Sem audit"></zzy-empty>'}
      </div>

      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">📲 Dispatches WhatsApp</h3>
        ${dispatches.length ? `<div style="overflow:auto;max-height:300px"><table class="pl-table">
          <thead><tr><th>Quando</th><th>RA</th><th>Líder</th><th>Status</th></tr></thead>
          <tbody>${dispatches.map(d => `<tr>
            <td><small>${fmtDateTime(d.created_at)}</small></td>
            <td><strong>#${d.numero_ra || '—'}</strong></td>
            <td>${escapeHtml(d.lider || d.destinatario || '—')}</td>
            <td><span class="pl-badge ${d.success || d.ok ? 'pl-status-ok' : 'pl-status-crit'}">${d.success || d.ok ? 'OK' : 'FAIL'}</span></td>
          </tr>`).join('')}</tbody></table></div>` : '<zzy-empty title="Sem dispatches"></zzy-empty>'}
      </div>

      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">⚡ Ações registradas (RA)</h3>
        ${acoes.length ? `<div style="overflow:auto;max-height:300px"><table class="pl-table">
          <thead><tr><th>Quando</th><th>RA</th><th>Ação</th><th>Operador</th><th>Obs</th></tr></thead>
          <tbody>${acoes.map(a => `<tr>
            <td><small>${fmtDateTime(a.created_at)}</small></td>
            <td><strong>#${a.numero_ra || '—'}</strong></td>
            <td><strong>${escapeHtml(a.acao_codigo || '—')}</strong></td>
            <td>${escapeHtml(a.operador || a.atendente || '—')}</td>
            <td><small style="color:var(--zzy-text-mute)">${escapeHtml((a.obs || '').slice(0, 50))}</small></td>
          </tr>`).join('')}</tbody></table></div>` : '<zzy-empty title="Sem ações"></zzy-empty>'}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

bootstrap();
